(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["in-home-demo"] && !Shopify.designMode) return;
  try {
    
  const AWS_ENDPOINT = 'https://k0c184zs11.execute-api.eu-west-1.amazonaws.com/in-home-demo';

  const successMessage = document.getElementById('home-demo-request-form-submit-message');
  const homeDemoRequestForm = document.getElementById('in-home-demo-form');

  if (homeDemoRequestForm) {
    homeDemoRequestForm.addEventListener('submit', async function (event) {
      event.preventDefault();

      const data = Object.fromEntries(new FormData(homeDemoRequestForm).entries());

      try {
        const response = await fetch(AWS_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });

        if (!response.ok) throw new Error('Request failed');

        homeDemoRequestForm.style.display = 'none';
        successMessage.style.display = 'block';
      } catch (_) {
        alert('Something went wrong. Please try again or contact us directly.');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-time-value"] && !Shopify.designMode) return;
  try {
    

let updateGraph = (variantPrice, currencySymbol) => {
  const lifeTimeValuesToChange = document.querySelectorAll(
    "span[data-life-time-value]"
  )

  let costPerYear = variantPrice / 100 / 365
  let costFor5Years = costPerYear / 5
  let costFor10Years = costPerYear / 10
  let arrayOfCost = [costPerYear, costFor5Years, costFor10Years]
  lifeTimeValuesToChange.forEach((value, currentIndex) => {
    value.textContent = formatNumber(arrayOfCost[currentIndex], currencySymbol)
  })
}

let formatNumber = (number, currencySymbol) => {
  return currencySymbol + number.toFixed(2) + " "
}

window.Shopify.lifeTimeValueUpdate = updateGraph

  } catch(e) { console.error(e); }
})();
})();
